import script from "./MergedCollection.vue?vue&type=script&setup=true&lang=js"
export * from "./MergedCollection.vue?vue&type=script&setup=true&lang=js"

import "./MergedCollection.vue?vue&type=style&index=0&id=1288e9d4&lang=scss&scoped=true"
script.__scopeId = "data-v-1288e9d4"

export default script